import { render, staticRenderFns } from "./spReformPrototype.vue?vue&type=template&id=23e12bea"
import script from "./spReformPrototype.vue?vue&type=script&lang=js"
export * from "./spReformPrototype.vue?vue&type=script&lang=js"
import style0 from "./spReformPrototype.vue?vue&type=style&index=0&id=23e12bea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports